// extracted by mini-css-extract-plugin
var _1 = "tnV4nXD_U9sivxp7WyP2";
export { _1 as "wrapper" }
